import CloudPriceList from '@/components/global-admin/pricing/CloudPriceList';
import PriceChangeLog from '@/components/global-admin/pricing/PriceChangeLog';

export default function CloudServersPage() {
  return (
    <div className="space-y-6" data-testid="cloud-servers-pricing-page">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Cloud servers</h2>
        <p className="text-muted-foreground">
          What each size costs us and what each region pays for it. A server keeps the price in
          force on the day it started, so nothing here changes an existing bill.
        </p>
      </div>

      <CloudPriceList />
      <PriceChangeLog />
    </div>
  );
}
